import type {
  PostAttackBlockReason,
  SkipAttackReasonType,
} from './trace-types';
import {
  type TraceConfidence,
  type TraceLabel,
  type TraceMetadata,
  type SignalLabel,
} from './trace-types';

export type SmokeTestHistoryMetadataInput = {
  attackLabel?: TraceLabel;
  labelRationale?: string;
  confidenceReason?: string;
  confidence?: TraceConfidence;
  analysis?: string;
  conclusion?: string;
  blockReason?: PostAttackBlockReason;
  ambiguityFactor?: string;
  evidences?: Array<{
    explanation: string;
    content?: string;
    data?: string;
    type?: string;
    artifactId?: string;
    evidenceId?: string;
    toolExecutionHarId?: string | null;
  }>;
  previousSignalLabel?: string;
  newSignalLabel?: string;
  skipAttackReason?: string;
  skipAttackReasonType?: SkipAttackReasonType;
};

const SIGNAL_LABELS: SignalLabel[] = [
  'COLD',
  'HOT',
  'PASSED',
  'EXPLOITED',
  'DUPLICATE',
  'BLOCKED',
];

function parseSignalLabel(label: string | undefined): SignalLabel | undefined {
  if (!label) {
    return undefined;
  }

  return SIGNAL_LABELS.includes(label as SignalLabel)
    ? (label as SignalLabel)
    : undefined;
}

export function mapTraceMetadataFromSmokeTestHistory(
  metadata: SmokeTestHistoryMetadataInput | null | undefined,
): TraceMetadata | undefined {
  if (!metadata) {
    return undefined;
  }

  return {
    label: metadata.attackLabel,
    labelRationale: metadata.labelRationale,
    confidenceReason: metadata.confidenceReason,
    confidence: metadata.confidence,
    analysis: metadata.analysis,
    conclusion: metadata.conclusion,
    blockReason: metadata.blockReason,
    ambiguityFactor: metadata.ambiguityFactor,
    evidences: metadata.evidences?.map((evidence) => ({
      explanation: evidence.explanation,
      content: evidence.content,
      data: evidence.data,
      type: evidence.type,
      artifactId: evidence.artifactId,
      evidenceId: evidence.evidenceId,
      toolExecutionHarId: evidence.toolExecutionHarId,
    })),
    previousSignalLabel: parseSignalLabel(metadata.previousSignalLabel),
    newSignalLabel: parseSignalLabel(metadata.newSignalLabel),
    skipAttackReason: metadata.skipAttackReason,
    skipAttackReasonType: metadata.skipAttackReasonType,
  };
}
